import React from "react";
import { CLASS_NAME } from "../../constants/ClassName";

interface FieldMappingProps {
    headers: string[];
    fieldMappings: Record<string, string>;
    requiredFields: string[];
    optionalFields: string[];
    onFieldMappingChange: (updatedMappings: Record<string, string>) => void;
}

const FieldMapping: React.FC<FieldMappingProps> = ({
    headers,
    fieldMappings,
    requiredFields,
    optionalFields,
    onFieldMappingChange,
}) => {
    const handleFieldMappingChange = (field: string, csvField: string) => {
        const updatedMappings = { ...fieldMappings, [field]: csvField };
        onFieldMappingChange(updatedMappings);
    };

    // Collect all currently selected values
    const selectedFields = Object.values(fieldMappings);

    return (
        <div className="mt-4">
            <h3 className="text-lg font-semibold mb-2">Field Mappings</h3>
            <div className="grid grid-cols-2 lg:grid-cols-6 md:grid-cols-4 gap-4">
                {[...requiredFields, ...optionalFields].map((field) => (
                    <div key={field} className="flex flex-col">
                        <label>
                            {field} {requiredFields.includes(field) && <span className="text-red-500">*</span>}
                        </label>
                        <div className="relative">
                            <select
                                id={`field-mapping-${field}`}
                                aria-label={`Field mapping for ${field}`}
                                value={fieldMappings[field] || ""}
                                onChange={(e) => handleFieldMappingChange(field, e.target.value)}
                                className={`${CLASS_NAME.formBorder} block appearance-none w-full p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-300 focus:border-blue-500 dark:focus:border-blue-300 transition shadow-sm`}>
                                <option value="">Not Provided</option>
                                {headers
                                    .filter(
                                        (csvField) =>
                                            !selectedFields.includes(csvField) || csvField === fieldMappings[field],
                                    ) // Exclude already selected headers, except the current field's value
                                    .map((csvField) => (
                                        <option key={csvField} value={csvField}>
                                            {csvField}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FieldMapping;